import dayjs from "dayjs";
import DateRangePicker from "../../ui/dateRangePicker";
import ReservationReportDailyChart from "./ui/chart";
import ReservationReportDailyTable from "./ui/table";
import { useEffect, useState } from "react";
import { requestReservationCountAndStatusByCenterAndLastedUpdateDateBetweenGroupBySignDay } from "../../../../service/report";
import { useSelector } from "react-redux";
import { RootState } from "../../../../modules";
import SuperAdminPassword from "../../../../components/SuperAdminPassword";

const ReportReservationDaily = () => {
    const [data, setData] = useState<any[]>([]);
    const { isSuperAdmin } = useSelector((state: RootState) => state.superAdmin);

    const startDate = dayjs().subtract(6, 'days')
    const getCheckInStatusToText = (status: string) => {
        switch (status) {
            case 'RESERVATION':
                return '예약'
            case 'CHECK_IN_RESERVATION_CANCELED':
                return '예약 취소'
            case 'CHECK_IN':
                return '출석'
            case 'ABSENT':
                return '결석'
        }
    }
    const mergeData = (data: any[]): any[] => {
        const merged = data.reduce((acc: any[], current) => {
            const existing = acc.find(item => item.status === current.status && item.day === current.day);
            if (existing) {
                existing.count += current.count;  // count를 합침
            } else {
                acc.push({ ...current });  // acc 배열에 추가
            }
            return acc;
        }, []);
        return merged;
    };

    const requestReportMember = (startDate: string, endDate: string) => {
        requestReservationCountAndStatusByCenterAndLastedUpdateDateBetweenGroupBySignDay(startDate, endDate)
            .then(res => { setData(res.data); })
            .catch(err => { console.log(err); });
    }
    const groupDataByName = (data: any[]) => {
        if (data.length === 0) return [];
        const grouped: { [key: string]: any } = {};
        data.forEach(item => {
            if (!grouped[item.signDay]) {
                grouped[item.signDay] = {
                    day: item.signDay,
                    reservationCount: 0,
                    RESERVATION: 0,
                    CHECK_IN_RESERVATION_CANCELED: 0,
                    CHECK_IN: 0,
                    ABSENT: 0,
                    ABSENTRatio: 0,
                };
            }
        })
        if (!grouped['Total']) {
            grouped['Total'] = {
                day: 'Total',
                reservationCount: data.reduce((acc, cur) => acc + (cur.reservationCount ?? 0), 0),
                RESERVATION: null,
                CHECK_IN_RESERVATION_CANCELED: null,
                CHECK_IN: null,
                ABSENT: null,
                ABSENTRatio: null,
            }
        }
        data.forEach(item => {
            switch (item.status) {
                case 'RESERVATION':
                    grouped[item.signDay].RESERVATION = item.reservationCount || 0;
                    grouped['Total'].RESERVATION += item.reservationCount || 0;
                    break;
                case 'CHECK_IN':
                    grouped[item.signDay].CHECK_IN = item.reservationCount || 0;
                    grouped['Total'].CHECK_IN += item.reservationCount || 0;
                    break;
                case 'ABSENT':
                    grouped[item.signDay].ABSENT = item.reservationCount || 0;
                    grouped['Total'].ABSENT += item.reservationCount || 0;
                    break;
                case 'CHECK_IN_RESERVATION_CANCELED':
                    grouped[item.signDay].CHECK_IN_RESERVATION_CANCELED = item.reservationCount || 0;
                    grouped['Total'].CHECK_IN_RESERVATION_CANCELED += item.reservationCount || 0;
                    break;
                default:
                    break;
            }
        });
        Object.values(grouped).forEach(item => { grouped[item.day].ABSENTRatio = (item.ABSENT / (item.RESERVATION + item.CHECK_IN + item.ABSENT) * 100).toFixed(2) + '%'; })
        return Object.values(grouped);
    }
    useEffect(() => {
        requestReportMember(startDate.format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])

    if (!isSuperAdmin) {
        return <SuperAdminPassword />
    }

    return <>
        <DateRangePicker
            startDate={startDate}
            onClick={(startDate: string, endDate: string) => requestReportMember(startDate, endDate)} />
        <br /><br />
        <ReservationReportDailyChart value={mergeData(data.filter((e: any) => e.status !== 'CLASS_BEFORE').map(q => ({ count: q.reservationCount, day: q.signDay, status: getCheckInStatusToText(q.status) })))} />
        <br /><br />
        <ReservationReportDailyTable data={groupDataByName(data).map((q, idx) => ({ ...q, key: idx }))} />
    </>
}

export default ReportReservationDaily;